export default __webpack_public_path__ + "static/icon-7a6e1baf360399d8be8bc340960a72dc.png";